const _version = "2.12.3"
function version() {
    return _version
}
export default version
